import * as React from 'react';
import { ReportCommonApi } from 'app/area/reports/types-api';
import { 
  useActionCreators, 
  useAutoExecuteState, 
  useDrillDownCallback, 
  useExecuteFavouriteEffect, 
  useFavouriteLayoutAttributes, 
  useLoadLayoutTypesEffect,
  useOnLoadOptionsDrillDownTo,
  useSelectedDrillDownReport, 
  useSelectedLayoutType, 
  useUpdateLayoutAttributesCallback
} from './hooks';
import { ChartState } from 'app/area/reports/containers/chart/types-store';
import { ChartView } from 'app/area/reports/containers/chart/chart-view';
import { useIntl } from 'react-intl';
import { useWorkingDefinitionAggregationState } from 'app/area/reports/containers/aggregation/hooks';
import { useWorkingDefinitionSelectedGroupByFields } from 'app/area/reports/containers/group-by/hooks';
import { useInstanceOptions } from 'app/area/favourite/favourite-context';
import { DrillDownCallback } from 'app/components/favourite-layout/favourite/common/drill-down-model';
import { ComplexValue } from 'app/infrastructure/ui/form/types';

export interface ChartContainerProps {
  favouriteId: number;
  chartState: ChartState;
  translation: any;
  requestCustomWidth?: (id: number, val: any) => void;
  drillDown?: DrillDownCallback;
  reflowHandle?: string;
  optionsDrillDownTo?: ComplexValue<number>[];
}

export const ChartContainerForApi = (api: ReportCommonApi) => ({
  favouriteId,
  chartState,
  translation,
  requestCustomWidth,
  drillDown,
  reflowHandle
}: ChartContainerProps) => {

  const intl = useIntl();

  const selectedLayoutType = useSelectedLayoutType();

  const {
    setLayoutType
  } = useActionCreators(api);

  const {
    toggleAutoExecution,
    autoExecute
  } = useAutoExecuteState();

  const onDrillDown = useDrillDownCallback(api, favouriteId, drillDown);

  const updateLayoutAttributes = useUpdateLayoutAttributesCallback(selectedLayoutType?.value);

  useLoadLayoutTypesEffect(api);

  useExecuteFavouriteEffect(
    api, autoExecute
  );

  const {
    selectedAggregationField 
  } = useWorkingDefinitionAggregationState();

  const selectedGroupByFields = useWorkingDefinitionSelectedGroupByFields();

  const { layoutAttributes, layoutAttributeOptions } = useFavouriteLayoutAttributes(chartState);

  const {
    hideVisualizationOptions, height
  } = useInstanceOptions();

  const onLoadOptionsDrillDownTo = useOnLoadOptionsDrillDownTo(api);

  const drillDownReport = useSelectedDrillDownReport();
  
  const { setDrillDownReport } = useActionCreators(api);

  return <ChartView
    autoExecute={autoExecute}
    toggleAutoExecution={toggleAutoExecution}
    drillDown={onDrillDown}
    updateLayoutAttributes={updateLayoutAttributes}
    setLayoutType={setLayoutType}
    translation={translation}
    chartState={chartState}
    selectedAggregationField={selectedAggregationField}
    selectedGroupByFields={selectedGroupByFields}
    layoutAttributes={layoutAttributes}
    layoutAttributeOptions={layoutAttributeOptions}
    selectedLayoutType={selectedLayoutType}
    intl={intl}
    hideVisualizationOptions={hideVisualizationOptions}
    requestCustomWidth={requestCustomWidth}
    reflowHandle={reflowHandle}
    height={height}
    onLoadDrillDownOptions={onLoadOptionsDrillDownTo}
    drillDownReport={drillDownReport}
    setDrillDownReport={setDrillDownReport}
  />;
};
